import * as R from 'ramda';
import debugLib from 'debug';

import { FACEBOOK_MACHINE_NAME } from '../../../../shared/constants/adPartnerConstants';

import { reducerWrapper } from '../support/utils';

import {
  SAVE_TOKEN,
  GET_USER_DATA,
  FB_LOGOUT,
  GET_AD_ACCOUNTS,
  GET_APP_INFO,
  CHECK_ATTRIBUTION_WINDOWS,
  VALIDATE_FB_APP_ID,
} from '../actions/FacebookActions';
// The FB_SAVE_CONFIG action is used in the AdPartnerReducer, not here

import { GET_AD_ACCOUNT_STATUS } from '../actions/SANPartnerActions';

const debug = debugLib('FacebookReducer');

const INIT_STATE = {
  tokenHasSaved: false,
  userData: {},
  adAccounts: [],
  businessAccounts: [],
  pixels: [],
  FBAppInfo: [],
  attribWindowInfo: {},
  adAccountStatus: {},
  loading: false,
  error: null,
  fbAppIdValidationResult: {},
};

function Handler(state = INIT_STATE, action) {
  debug('Receive action type', action.type);
  switch (action.type) {
    case SAVE_TOKEN.response:
      const { tokenHasSaved } = action.data;

      return R.merge(state, {
        tokenHasSaved,
        loading: false,
      });

    case GET_USER_DATA.response:
      const { userData } = action.data;

      return R.merge(state, {
        userData,
        loading: false,
      });

    case FB_LOGOUT.response:
      return INIT_STATE;

    case GET_AD_ACCOUNTS.response:
      const { adAccounts } = action.data;
      return R.merge(state, {
        adAccounts,
        loading: false,
      });

    case GET_APP_INFO.response:
      const { FBAppInfo } = action.data;
      return R.merge(state, {
        FBAppInfo,
        loading: false,
      });

    case CHECK_ATTRIBUTION_WINDOWS.response:
      const newAttribWindow = R.merge(state.attribWindowInfo, {
        ...action.data,
      });
      return R.merge(state, {
        attribWindowInfo: newAttribWindow,
        loading: false,
      });

    case GET_AD_ACCOUNT_STATUS.response:
      const adAccountStatus = R.path([FACEBOOK_MACHINE_NAME], action.data) || {};
      return R.merge(state, {
        adAccountStatus,
      });

    case VALIDATE_FB_APP_ID.response:
      return {
        ...state,
        fbAppIdValidationResult: action.data,
        loading: false,
      };

    default:
      return state;
  }
}

const Facebook = reducerWrapper(INIT_STATE, Handler, {
  request: [SAVE_TOKEN, GET_USER_DATA, FB_LOGOUT, GET_AD_ACCOUNTS, GET_APP_INFO, GET_AD_ACCOUNT_STATUS, VALIDATE_FB_APP_ID],
  error: [SAVE_TOKEN, GET_USER_DATA, FB_LOGOUT, GET_AD_ACCOUNTS, GET_APP_INFO, GET_AD_ACCOUNT_STATUS, VALIDATE_FB_APP_ID],
  resetOn: ['APP_CHANGE'],
});

export default Facebook;
